<template>
  <div class="cpc">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>
    <div class="table">
      <div class="table-head">
        <div class="table-head-search">
          <ButtonGroups :pagination="pagination" :tableData="tableData" @pageChange="onPageChange" />
          <div class="filters">
            <div class="filter-item">
              <span class="mid-filter-title">Title:</span>
              <a-input v-model:value="query.keyword" placeholder="Title" allow-clear style="width: 220px" />
            </div>
            <div class="statusFilter">
              <span class="mid-filter-title">ASIN:</span>
              <a-input v-model:value="query.asins" placeholder="ASIN" allow-clear style="width: 180px" />
            </div>
            <div class="statusFilter" ref="topRefMarketplace">
              <span class="mid-filter-title">Marketplace:</span>
              <artmisads-select style="width: 200px" :width="350" class="country" :dropdownMatchSelectWidth="false"
                v-model:value="query.marketplace" :getPopupContainer="() => $refs.topRefMarketplace"
                @change="(value, option) => setFilter('marketplace', value)">
                <a-select-option class="country-select-item" v-for="item in Object.keys(CURRENCY_MAPPER)"
                  :key="item.toLowerCase()" :value="CURRENCY_MAPPER[item].host"
                  :currency="CURRENCY_MAPPER[item].currency">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#icon-guoqi-' + item.toLowerCase()"></use>
                  </svg>{{ CURRENCY_MAPPER[item].host }}
                </a-select-option>
              </artmisads-select>
            </div>
          </div>

        </div>
        <div class="filters-box" ref="filterContentRef">
          <div class="filters-box-content">
            <div class="filter-item">
              <div class="label">Status</div>
              <div class="checkbox">
                <a-checkbox v-model:checked="query.changeStatus">Active</a-checkbox>
                <a-checkbox v-model:checked="query.changeFinished">Finished</a-checkbox>
                <!-- <a-checkbox v-model:checked="query.changeIncoming">Incoming</a-checkbox> -->
              </div>
            </div>
            <div class="filter-item">
              <div class="label">Link Type</div>
              <div class="checkbox">
                <a-checkbox v-model:checked="query.changeAttribution">Attribution</a-checkbox>
                <a-checkbox v-model:checked="query.changeAssociate">Associate</a-checkbox>
              </div>
            </div>
            <div class="filter-item">
              <div class="label">Starts On or After:</div>
              <a-date-picker style="width: 180px" :value="query.startAt || null" @change="onStartDateChange" />
            </div>
            <div class="filter-item">
              <div class="label">Ends On or Before:</div>
              <a-date-picker style="width: 180px" :value="query.endAt || null" :disabled-date="disabledEndDate"
                @change="onEndDateChange" />
            </div>
          </div>

        </div>

      </div>

      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="tableData"
        :change="onTableChange" :loading="load" :scroll="{ x: 1650 }">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'title'">
            <a-tooltip placement="topLeft" :title="titleOverflowTip(record, index) ? record.title : ''">
              <span class="title-cell text-style" @mouseenter="onTitleCellEnter($event, record, index)">{{ record.title
                }}</span>
            </a-tooltip>
          </template>
          <template v-else-if="column.key === 'asin'">
            <div v-if="asinStackView(record).kind === 'images'" class="asin-stack">
              <div class="asin-stack-avatars" aria-hidden="true">
                <div v-for="(url, i) in asinStackView(record).visibleUrls" :key="`img-${record.id}-${i}-${url}`"
                  class="asin-stack-item" :style="{ zIndex: i + 1 }">
                  <img :src="url" alt="" />
                </div>
                <div v-if="asinStackView(record).more > 0" class="asin-stack-item asin-stack-more"
                  :style="{ zIndex: asinStackView(record).visibleUrls.length + 1 }">
                  +{{ asinStackView(record).more }}
                </div>
              </div>
            </div>
            <div v-else-if="asinStackView(record).kind === 'countOnly'" class="asin-stack-count-only">
              <span>{{ asinStackView(record).total }} ASINs</span>
            </div>
            <span v-else-if="record.asin" class="asin-stack-fallback">{{ record.asin }}</span>
            <span v-else class="asin-stack-empty">—</span>
          </template>
          <template v-if="column.key === 'cpc'">
            <div class="info-item">
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                  <span class="item-text">Attribution</span>
                </div>
                <div class="info-item-row-value">
                  {{ Array.isArray(record.availableLinkTypeLabels) && record.availableLinkTypeLabels.includes('Attribution')?CURRENCY_DATA_MAPPER[record.currency]+record.attributionCpcUnitPrice:'N/A' }}
                  
                </div>
              </div>
              <div class="info-item-row">
                <div class="item">
                  <img src="../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                  <span class="item-text">Associate
                  </span>

                </div>
                <div class="info-item-row-value">
                  {{ Array.isArray(record.availableLinkTypeLabels) && record.availableLinkTypeLabels.includes('Associate')?CURRENCY_DATA_MAPPER[record.currency]+record.associateCpcUnitPrice:'N/A' }}
                
                </div>
              </div>

            </div>
          </template>
          <template v-if="column.key === 'budget'">
            <div>
              <p><span class="title-text">Total:</span> <span class="value-text green">{{
                CURRENCY_DATA_MAPPER[record.currency] }}{{ record.totalBudget }}</span></p>
              <p><span class="title-text">Remain:</span> <span class="value-text red">{{
                CURRENCY_DATA_MAPPER[record.currency] }}{{ record.budgetRemaining }}</span></p>
            </div>
          </template>
          <template v-if="column.key === 'startDate'">
            <div class="text-style">
              {{ moment(record.startDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}
            </div>

          </template>
          <template v-if="column.key === 'endDate'">
            <div class="text-style">
              {{ moment(record.endDateTimestamp).tz(timeZone).format('YYYY-MM-DD') }}
            </div>
          </template>
          <template v-if="column.key === 'linkType'">
            <div class="link-type-cell"
              v-if="Array.isArray(record.availableLinkTypeLabels) && record.availableLinkTypeLabels.includes('Attribution')">
              <div class="item">
                <img src="../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                <span class="item-text">Attribution</span>
              </div>
            </div>
            <div class="link-type-cell"
              v-if="Array.isArray(record.availableLinkTypeLabels) && record.availableLinkTypeLabels.includes('Associate')"
              style="margin-top: 10px;">
              <div class="item">
                <img src="../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                <span class="item-text">Associate
                </span>

              </div>
            </div>
          </template>
          <template v-if="column.key === 'cap'">
            <div>
              <p>
                <span class="title-text">Total: {{ record.publisherTotalCapUpTo ? '(UP To)' : '' }}</span>

                <span class="value-text green"> {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.publisherTotalCap
                  }}</span>

              </p>
              <p>
                <span class="title-text">Daily:{{ record.publisherDailyCapUpTo ? '(UP To)' : '' }}</span>
                <span class="value-text red"> {{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.publisherDailyCap
                  }}</span>

              </p>
            </div>
          </template>
          <template v-if="column.key === 'status'">
            <Status :type="statusType(record.status)" :text="record.status" :noBorder="true" />
          </template>

          <template v-if="column.key === 'action'">
            <div class="action-cell">
              <artmisads-select-button size="small" @click="viewCampaign(record)">View</artmisads-select-button>
            </div>
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue"
import { useRouter } from "vue-router"
import breadcrumbs from "~/pages/seller/breadcrumbs.vue"
import ButtonGroups from "@/pages/seller/Brands/components/buttonGroups.vue"
import Status from "~/components/Status.vue"
import { cpcCampaignsApi } from "~/server"
import { CURRENCY_MAPPER, COUNTRY_TIME_TZ, CURRENCY_DATA_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
import moment from "moment"

const store = useUserInfoStore()
const userInfo = store.userInfo
const timeZone = COUNTRY_TIME_TZ[userInfo.countryCode] || 'US'
const breadcrumbsData = {
  title: "Cpc",
  color: "#26AADC",
  des: "Cost-Per-Click (CPC) Campaigns",
  hasTitleIcon: false,
  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Campaigns",
      path: "/publisher/campaigns/index",
    },
    {
      name: "Cpc",
      path: "/publisher/campaigns/myCampaigns",
    },
  ],
}

const load = ref(false)
const router = useRouter()
const statusFilterRef = ref(null)
const linkTypeFilterRef = ref(null)
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const query = reactive({
  keyword: "",
  asins: "",
  status: "",
  publisherId: "",
  linkType: "",
  startAt: null,
  endAt: null,
  changeStatus: false,
  changeFinished: false,
  changeAttribution: false,
  changeAssociate: false,
  marketplace: CURRENCY_MAPPER[countryCode].host,
})

const hasPublisherId = (v) => v !== "" && v != null

const activeFilterCount = computed(() => {
  let n = 0
  if (String(query.title || "").trim()) n += 1
  if (String(query.asin || "").trim()) n += 1
  if (hasPublisherId(query.publisherId)) n += 1
  if (query.changeStatus) n += 1
  if (query.changeFinished) n += 1
  if (query.changeAttribution) n += 1
  if (query.changeAssociate) n += 1
  if (query.startAt) n += 1
  if (query.endAt) n += 1
  return n
})

const tableData = ref([

])

const titleOverflow = reactive({})

const titleRowKey = (record, index) => record.id ?? index

const titleOverflowTip = (record, index) =>
  !!record.title && !!titleOverflow[titleRowKey(record, index)]

const onTitleCellEnter = (e, record, index) => {
  const el = e?.currentTarget
  if (!el) return
  titleOverflow[titleRowKey(record, index)] =
    el.scrollWidth > el.clientWidth
}

const ASIN_STACK_VISIBLE = 3

/** 列表行里的商品摘要，接口一般为 record.products: [{ productId, asin, imageUrl, ... }] */
const asinStackProductList = (record) => {
  const raw =
    record?.products ??
    record?.asinProducts ??
    record?.productList ??
    record?.productThumbnails ??
    []
  return Array.isArray(raw) ? raw : []
}

const isUsableProductImageUrl = (raw) => {
  const u = String(raw ?? "").trim()
  if (!u || u === "string") return false
  return /^https?:\/\//i.test(u) || u.startsWith("//") || u.startsWith("data:")
}

const asinStackImageUrls = (record) => {
  const arr = asinStackProductList(record)
  const urls = []
  const seen = new Set()
  for (const p of arr) {
    const u = String(p?.imageUrl || p?.productImage || p?.image || "").trim()
    if (!u || seen.has(u)) continue
    seen.add(u)
    if (isUsableProductImageUrl(u)) urls.push(u)
  }
  return urls
}

const asinStackTotalCount = (record) => {
  const products = asinStackProductList(record)
  const fromList = products.length
  const urls = asinStackImageUrls(record)
  const n = Number(
    record?.productCount ??
    record?.productsCount ??
    record?.totalProducts ??
    record?.asinCount ??
    0,
  )
  if (fromList > 0) {
    if (Number.isFinite(n) && n > 0) return Math.max(n, fromList)
    return fromList
  }
  if (Number.isFinite(n) && n > 0) return Math.max(n, urls.length)
  return urls.length
}

/** 列表单元展示：有图叠放；仅有数量时显示文案 */
const asinStackView = (record) => {
  const urls = asinStackImageUrls(record)
  const total = asinStackTotalCount(record)
  if (total <= 0) return { kind: "none" }
  const visibleUrls = urls.slice(0, ASIN_STACK_VISIBLE)
  const more = Math.max(0, total - ASIN_STACK_VISIBLE)
  if (!visibleUrls.length) {
    return { kind: "countOnly", total, more }
  }
  return { kind: "images", visibleUrls, more, total }
}

const asinStackTooltip = (record) => {
  const products = asinStackProductList(record)
  const asins = products
    .map((p) => String(p?.asin || "").trim())
    .filter(Boolean)
  if (asins.length) {
    const head = asins.slice(0, 25).join(", ")
    return asins.length > 25 ? `${head}…` : head
  }
  if (record?.asin) return String(record.asin)
  return ""
}


const columns = ref([
  { title: "Title", dataIndex: "title", key: "title", width: 180 },
  { title: "ASIN", dataIndex: "asin", key: "asin", width: 200 },
  { title: "CPC", dataIndex: "cpc", key: "cpc", width: 200 },
  { title: "Budget", dataIndex: "budget", key: "budget", width: 170 },
  {
    title: "BudgetCap",
    dataIndex: "cap",
    key: "cap",
    width: 220,
  },
  { title: "StartDate", dataIndex: "startDate", key: "startDate", width: 130 },
  { title: "EndDate", dataIndex: "endDate", key: "endDate", width: 130 },
  { title: "LinkType", dataIndex: "linkType", key: "linkType", width: 140 },

  { title: "Status", dataIndex: "status", key: "status", width: 130 },
  { title: "Action", key: "action", width: 150, fixed: "right" },
])

const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ["1", "20", "30", "40", "50"],
})

const handleChangeStatus = () => {
  query.status = query.changeStatus ? 'active' : ''
}
const handleChangeFinished = () => {
  query.status = query.changeFinished ? 'finished' : ''
}

// const pagedData = computed(() => {
//   const start = (pagination.current - 1) * pagination.pageSize
//   const end = start + pagination.pageSize
//   return filteredData.value.slice(start, end)
// })

const onTableChange = ({ current, pageSize }) => {

  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getCpcCampaignsList()
}

const onPageChange = (current) => {
  pagination.current = current
  getCpcCampaignsList()
}

const isEndAfterStart = (endDate, startDate) => {
  if (!endDate || !startDate) return true
  return moment(endDate).startOf("day").valueOf() > moment(startDate).startOf("day").valueOf()
}

const disabledEndDate = (current) => {
  if (!query.startAt) return false
  return !isEndAfterStart(current, query.startAt)
}

const onStartDateChange = (date) => {
  query.startAt = date || null
  if (query.startAt && query.endAt && !isEndAfterStart(query.endAt, query.startAt)) {
    query.endAt = null
  }
}

const onEndDateChange = (date) => {
  if (date && query.startAt && !isEndAfterStart(date, query.startAt)) {
    query.endAt = null
    return
  }
  query.endAt = date || null
}

const onSearch = () => {
  pagination.current = 1

  getCpcCampaignsList()
}
watch(query, (newVal) => {
  pagination.current = 1
  getCpcCampaignsList()
}, { deep: true })
const getCpcCampaignsList = async () => {
  let param = {
    ...query,
    page: pagination.current,
    size: pagination.pageSize,

  }
  if (param.changeStatus) {
    param.status = 'ACTIVE'
  }
  if (param.changeFinished) {
    param.status = 'FINISHED'
  }
  if (param.changeStatus && param.changeFinished) {
    param.status = ''
  }
  if (param.changeAttribution) {
    param.linkType = 'ATTRIBUTION'
  }
  if (param.changeAssociate) {
    param.linkType = 'ASSOCIATE'
  }
  if (param.changeAttribution && param.changeAssociate) {
    param.linkType = ''
  }
  delete param.changeStatus
  delete param.changeFinished
  delete param.changeAttribution
  delete param.changeAssociate
  if (param.startAt) {
    param.startDateTimestamp = moment(moment(param.startAt).format('YYYY-MM-DD') + ' 00:00:00').valueOf()
  }
  if (param.endAt) {
    param.endDateTimestamp = moment(moment(param.endAt).format('YYYY-MM-DD') + ' 23:59:59').valueOf()
  }
  delete param.startAt
  delete param.endAt
  const { data } = await cpcCampaignsApi.getMyCpcCampaigns(param)

  tableData.value = data.data
  pagination.total = data.total
}
const statusType = (status) => {
  if (status === "ACTIVE") return "active"
  if (status === "FINISHED") return "finished"
  return "inactive"
}

const resetFilters = () => {
  Object.assign(query, {
    title: "",
    asin: "",
    status: "",
    publisherId: "",
    linkType: "",
    startAt: null,
    endAt: null,
    changeStatus: false,
    changeFinished: false,
    changeAttribution: false,
    changeAssociate: false,
  })

  onSearch()
}

const viewCampaign = (record) => {
  router.push(
    `/publisher/campaigns/details/${record.id}?joinedByMe=true`,

  )
}

const editCampaign = (record) => {
  router.push({
    name: "seller cpc create",
    query: {
      mode: "edit",
      campaignId: record.id,
    },
  })
}
getCpcCampaignsList()

</script>
<style scoped lang="less">
.filters-box {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  padding: 15px 16px;
  margin: 16px 0;
  width: 100%;
  border-radius: 8px;
  background: #F8F7FC;
  justify-content: space-between;

  .filters-box-content {
    display: flex;
    gap: 22px;

  }

  .filter-item {
    .label {

      font-size: 13px;
      font-weight: 600;
      height: 18px;
      // opacity: 0.7;
      letter-spacing: 0.3px;
      line-height: 18px;
      color: #0f0629;
      margin-bottom: 4px;
    }
  }

  .checkbox {
    display: flex;
    height: 32px;
    padding: 0 8px;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: #EAE8F0;

  }

  .statusFilter {

    // position: relative;
    z-index: 2;
    // margin-left: 18px;
    // opacity: 0.7;
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-2);
    letter-spacing: 0.4px;
    line-height: 20px;
  }
}

.table-head-search {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.text-style {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: rgba(15, 6, 41, 1);
}

.title-text {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(15, 6, 41, 1);
}

.value-text {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-transform: uppercase;

}

.green {
  color: rgba(0, 153, 71, 1);
}

.red {
  color: rgba(235, 78, 61, 1);
}

.cpc {
  padding: 16px;
  padding-top: unset;
}

.item {
  display: flex;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #f1f0f5;
  min-width: 111px;

  .icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-text {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .info-item-row-value {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0px;
    text-transform: uppercase;
    color: rgba(15, 6, 41, 1);
  }

}

.link-type-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 111px;
  flex-direction: column;

}

.table {
  padding: 0 16px 16px;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: var(--section-box-shadow-6);
}

.table-head {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 16px 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px !important;
  // justify-content: flex-end;
}

.filterBar {
  padding-bottom: 12px;
}

.filterBar-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.statusFilter {
  display: flex;
  align-items: center;
}

.publisher-filter {
  min-width: 240px;
}

.publisher-select-wrap {
  width: 200px;
}

.mid-filter-title {
  margin-right: 8px;
  color: #5f6572;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.reset-filters {
  font-family: Sora;
  font-weight: 400;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: rgba(108, 61, 242, 1);
  cursor: pointer;
}

.title-cell {
  display: inline-block;
  max-width: 165px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

}

.asin-stack {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
}

.asin-stack-avatars {
  display: inline-flex;
  align-items: center;
  padding-left: 2px;
}

.asin-stack-item {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  // border: 2px solid #fff;
  box-sizing: border-box;
  overflow: hidden;
  margin-left: -10px;
  flex-shrink: 0;
  background: #f3f4f6;
  box-shadow: 0 0 0 1px rgba(15, 6, 41, 0.06);

  &:first-child {
    margin-left: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.asin-stack-more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0px;

  color: rgba(87, 81, 105, 1);
  background: rgba(241, 240, 245, 1);
  line-height: 1;
}

.asin-stack-empty,
.asin-stack-fallback {
  color: #9ca3af;
  font-size: 13px;
}

.asin-stack-fallback {
  color: #374151;
}

.asin-stack-count-only {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: default;
}

.link-cell {
  color: #7d64ff;
  text-decoration: none;
}

.action-cell {
  display: flex;
  gap: 10px;

  a {
    color: #7d64ff;
    text-decoration: none;
  }
}

@media (max-width: 1200px) {
  .table-head {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>